import { useMutation } from "@apollo/client/react";
import toast from "react-hot-toast";
import moment from 'moment';
import { SAVE_INDICATION } from "../../../../../data/graphQL/mutations/GestionAsistencial/saveIndication";
import { CompareDates } from "../../../../../utils/helpers";

export function useTabIndicationAddIndicacionOnSubmit({
  idEvaluacion,
  formValues,
  insumosAdded,
  handleCloseDialog,
  refetch,
  refetchSolicitudes
}) {
  const [saveIndicacion, { loading: saveIndicationLoading }] = useMutation(SAVE_INDICATION);

  const formatInsumosPayload = (insumosAdded) => {
    const insumosFormatted = insumosAdded.map((item) => ({
      idInsumo: item.idInsumoN,
      cantidad: +item.cantidad,
      idUnidad: +item.idUnidad
    }));

    return insumosFormatted;
  };

  const onSubmitSaveIndication = () => {
    // if (!moment(formValues.fechaDesde, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day'))
    // {
    //   return toast.error(
    //     "La fecha desde no puede ser anterior a la fecha actual."
    //   );
    // }

    if (moment(formValues.fechaHasta).isBefore(moment(formValues.fechaDesde))) {
      return toast.error(
        "La fecha hasta no puede ser menor que la fecha desde."
      );
    } 
    // if (CompareDates(formValues.fechaDesde, formValues.fechaHasta) === 1) {
    //   return toast.error(
    //     "La fecha desde debe ser menor o igual a la fecha hasta."
    //   );
    // }

    if (formValues.observacion == "") {
      return toast.error("El motivo de solicitud es obligatorio.");
    }

    saveIndicacion({
      variables: {
        input: {
          idEvaluacion,
          idIndicacion: 0,
          fechaDesde: moment(formValues.fechaDesde).format("YYYY-MM-DD"),
          fechaHasta: moment(formValues.fechaHasta).format("YYYY-MM-DD"),
          observacion: formValues.observacion,
          productos: formatInsumosPayload(insumosAdded)
        }
      },
      onCompleted: (data) => {
        const { success, error } = data?.saveIndicacion ?? {};
        if (success==false) {
          toast.error(error);
        } else {
          toast.success("Solicitud creada con éxito");
          refetch();
          refetchSolicitudes();
          handleCloseDialog();
        }
      }
    });
  };

  return { onSubmitSaveIndication, saveIndicationLoading };
}